// extracted by mini-css-extract-plugin
module.exports = {"card":"_7368f3b7 pv3 ph0 mr3 mb3 bg-white br2 fl w-100-l w-100 mb0 ba b--black-10","cardHeader":"_7adb9669 pt3 pb1 bg-white br2 mb3"};